import { Doc } from '@dadohr/shared/domainTypes/document';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { sortBy } from 'lodash';
import { AutocompleteSingle } from '../../../components/Autocomplete';
import { toSearchTermRegexp } from '../../../services/user';
import { getAllOrgs } from '../../services/orgs';

export const OrgSelector = ({
  value,
  onChange,
  label
}: {
  value: Doc<IOrganization> | null;
  onChange: (nextValue: Doc<IOrganization> | null) => void;
  label?: React.ReactNode;
  // more to come later
}) => {
  return (
    <AutocompleteSingle
      label={label}
      value={value}
      onChange={onChange}
      getOptionLabel={(o) => o.data.name}
      options={() => getAllOrgs().then((os) => sortBy(os, (o) => o.data.name))}
      fullWidth
      filterOptions={(os, s) => {
        const t = toSearchTermRegexp(s.inputValue);
        return os.filter((o) => t.test(o.data.name));
      }}
    />
  );
};
